import { ActionTypes } from './actions';

const defaultState = {
    showPictures: false,
    currentPicture: 0,
};


export const pictureGalleryReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.SHOW_PICTURE_GALLERY:
            return {
                ...state,
                showPictures: true,
                currentPicture: 0,
                pictures: action.payload,
            };

        case ActionTypes.CLOSE_PICTURE_GALLERY:
            return {
                ...state,
                showPictures: false,
            };

        case ActionTypes.SELECT_PICTURE:
            return {
                ...state,
                currentPicture: action.payload,
            };

        case ActionTypes.NEXT_PICTURE:
            return {
                ...state,
                currentPicture: state.currentPicture === state.pictures.length - 1 ? 0 : state.currentPicture + 1,
            };

        case ActionTypes.PREVIOUS_PICTURE:
            return {
                ...state,
                currentPicture: state.currentPicture === 0 ? state.pictures.length - 1 : state.currentPicture - 1,
            };

        default:
            return state;
    }
};
